interface IContractsCreationFromFileError {
    message: string;
    body: string;
}
class ContractsCreationFromFileError implements IContractsCreationFromFileError {
    body: string;
    message: string;

    constructor(e: IContractsCreationFromFileError) {
        this.body = e.body;
        this.message = e.message;
    }
}

enum ContractsCreationFromFileStatus {
    Done = 'Done',
    Partial = 'Partial',
    Failure = 'Failure'
}

interface IContractsCreationFromFileResponse {
    errors: IContractsCreationFromFileError[];
    contractsIds: number[];
    hasErrors: boolean;
    hasContracts: boolean;
    status: ContractsCreationFromFileStatus;
}

export interface IContractsCreationFromCsvResponse extends IContractsCreationFromFileResponse {
    lineErrors: number[];
}


export class ContractsCreationFromCsvResponse implements IContractsCreationFromCsvResponse {
    contractsIds: number[];
    errors: ContractsCreationFromFileError[];
    hasContracts: boolean;
    hasErrors: boolean;
    lineErrors: number[];
    status: ContractsCreationFromFileStatus;

    constructor(r: IContractsCreationFromCsvResponse) {
        this.contractsIds = r.contractsIds;
        this.errors = r.errors.map(e => new ContractsCreationFromFileError(e));
        this.hasContracts = r.hasContracts;
        this.hasErrors = r.hasErrors;
        this.lineErrors = r.lineErrors;
        this.status = r.status;

        /*// ensure data to be coherent
        if (this.isSuccessful()) {
            if (this.errors.length > 0) {
                console.warn(`File elaboration is successful but there are some errors`);
                this.status = ContractsCreationFromFileStatus.Partial;
                this.hasErrors = true;
            }
        } else {
            // ensure to have at least an error
            if (this.errors.length === 0) {
                console.warn(`File elaboration is not successful but there are no errors`);
                this.errors.push(new ContractsCreationFromFileError({ body: null, message: 'Errore sconosciuto' }));
                this.hasErrors = true;
            }
        }*/
    }

    isSuccessful(): boolean {
        return this.status === ContractsCreationFromFileStatus.Done;
    }

    isFailure(): boolean {
        return this.status === ContractsCreationFromFileStatus.Failure;
    }

}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/interfaces/contractsCreationFromFileResponse.ts